<div class="col-12">
    <div class="groupComponentHeading" *ngIf="groupPortalDataService.groupList.groupInvoices.length> 0">
        <div class="col-5 members pl-0">My Group</div>
    </div>

    <div class="row grpTitles">
        <hr class="gpTborder w-100 mt-0 mb-3 mx-3" />
        <div class="col-12 subTitle py-3">
            <strong>{{
                groupPortalDataService.groupList.GroupInfo?.residencyDetail
                ? "Residency Information"
                : "Group Information"
                }}</strong>
            <div style="float: right;" class="bkg-circle {{
                !groupPortalDataService.editResidencyInformation
                ? 'pencil'
                : 'icon-closex'
                }}">
                <a (click)="toggleSection('editResidencyInformation')">
                    <i class="fa {{
                        !groupPortalDataService.editResidencyInformation
                        ? 'fa-pencil'
                        : ''
                        }}"></i>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="!groupPortalDataService.editResidencyInformation">
        <div class="py-1" *ngIf="
            groupPortalDataService.groupList.GroupInfo?.attention !== null &&
            groupPortalDataService.groupList.GroupInfo?.attention !== ''
            ">
            {{ groupPortalDataService.groupList.GroupInfo?.attention }}
        </div>
        <div class="py-1" *ngIf="
            groupPortalDataService.groupList.GroupInfo?.street !== null &&
            groupPortalDataService.groupList.GroupInfo?.street !== ''
            ">
            {{ groupPortalDataService.groupList.GroupInfo?.street }}
        </div>
        <div class="py-1" *ngIf="
            groupPortalDataService.groupList.GroupInfo?.apt !== null &&
            groupPortalDataService.groupList.GroupInfo?.apt !== ''
            ">
            {{ groupPortalDataService.groupList.GroupInfo?.apt }}
        </div>

        <div class="py-1" *ngIf="
            (groupPortalDataService.groupList.GroupInfo?.city !== null &&
            groupPortalDataService.groupList.GroupInfo?.city !== '') ||
            (groupPortalDataService.groupList.GroupInfo?.state !== null &&
            groupPortalDataService.groupList.GroupInfo?.state !== '')
            ">
            {{groupPortalDataService.groupList.GroupInfo?.city}} {{
            groupPortalDataService.groupList.GroupInfo?.city !== null &&
            groupPortalDataService.groupList.GroupInfo?.city !== "" &&
            groupPortalDataService.groupList.GroupInfo?.state !== null &&
            groupPortalDataService.groupList.GroupInfo?.state
            !== "" ? ", " : "" }} {{
            groupPortalDataService.groupList.GroupInfo?.state }}
        </div>
        <div class="py-1" *ngIf="
            groupPortalDataService.groupList.GroupInfo?.zip !== null &&
            groupPortalDataService.groupList.GroupInfo?.zip !== ''
            ">
            {{ groupPortalDataService.groupList.GroupInfo?.zip }}
        </div>
        <div class="py-1" *ngIf="
            groupPortalDataService.groupList.GroupInfo?.country !== null &&
            groupPortalDataService.groupList.GroupInfo?.country !== ''
            ">
            {{
            getCountryFromCode(groupPortalDataService.groupList.GroupInfo?.country)
            }}
        </div>
    </div>
    <div class="FlowupLabels col-8 p-0" *ngIf="groupPortalDataService.editResidencyInformation">

        <div class="fl_wrap
            {{(groupPortalDataService.groupList.FormGroupInfo?.country !== null &&
            groupPortalDataService.groupList.FormGroupInfo?.country !== '' ? '' :
            (formsubmitted ? ' validation-error' : ''))}}" [ngClass]="{
            populated: groupPortalDataService.groupList.FormGroupInfo?.country
            }">
            <label class="fl_label" for="Country">Country</label>
            <select class="fl_input" name="Country" [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.country"
                (change)="onCountrySelect($event.target.value)" required="required">
                <option value=""></option>
                <option *ngFor="let obj of dataService.uidata?.Countries" [value]="obj.acep_iso2code">{{ obj.acep_name
                    }}</option>
            </select>
            <span class="validationhead">Required</span>
        </div>

        <div class="fl_wrap" [ngClass]="{
            populated:
            groupPortalDataService.groupList.FormGroupInfo &&
            groupPortalDataService.groupList.FormGroupInfo?.attention
            }">
            <label class="fl_label" for="groupName">Organization</label>
            <input class="fl_input" name="groupName" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.attention" />

        </div>
        <div class="fl_wrap
            {{(groupPortalDataService.groupList.FormGroupInfo?.street !== null &&
            groupPortalDataService.groupList.FormGroupInfo?.street !== '' ? '' :
            (formsubmitted ? ' validation-error' : ''))}}" [ngClass]="{
            populated: groupPortalDataService.groupList.FormGroupInfo?.street
            }">
            <label class="fl_label" for="street">Address 1</label>
            <input class="fl_input" name="street" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.street" />
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap" [ngClass]="{
            populated:
            groupPortalDataService.groupList.FormGroupInfo &&
            groupPortalDataService.groupList.FormGroupInfo?.apt
            }">
            <label class="fl_label" for="apt">Address 2</label>
            <input class="fl_input" name="apt" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.apt" />

        </div>




        <div class="fl_wrap
            {{(groupPortalDataService.groupList.FormGroupInfo?.city !== null &&
            groupPortalDataService.groupList.FormGroupInfo?.city !== '' ? '' :
            (formsubmitted ? ' validation-error' : ''))}}" [ngClass]="{
            populated: groupPortalDataService.groupList.FormGroupInfo?.city
            }">
            <label class="fl_label" for="city">City</label>
            <input class="fl_input" name="city" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.city" />
            <span class="validationhead">Required</span>
        </div>


        <div *ngIf="groupPortalDataService.ui_stateprovinces.length> 0" class="fl_wrap
            {{((groupPortalDataService.groupList.FormGroupInfo?.state !== null &&
            groupPortalDataService.groupList.FormGroupInfo?.state !== '') ||
            groupPortalDataService.ui_stateprovinces.length <1 ? '' :
                (formsubmitted ? ' validation-error' : ''))}}" [ngClass]="{
                populated: groupPortalDataService.groupList.FormGroupInfo?.state
                }">
            <label class="fl_label" for="StateProvince">State/Province</label>
            <select class="fl_input" name="StateProvince"
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.state">
                <option value=""></option>
                <option *ngFor="let obj of
                        groupPortalDataService.ui_stateprovinces" [value]="obj.acep_isocode">{{ obj.acep_name }}
                </option>
            </select>
            <span class="validationhead">Required</span>
        </div>
        <div class="fl_wrap
                {{(groupPortalDataService.groupList.FormGroupInfo?.zip !== null &&
                groupPortalDataService.groupList.FormGroupInfo?.zip !== '' ||
                groupPortalDataService.groupList.FormGroupInfo?.country !== 'US' ?
                '' : (formsubmitted ? ' validation-error' : ''))}}" [ngClass]="{
                populated: groupPortalDataService.groupList.FormGroupInfo?.zip
                }">
            <label class="fl_label" for="zip">Zip/Postal code</label>
            <input class="fl_input" name="zip" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.zip" />
            <span class="validationhead">Required</span>
        </div>

    </div>
    <div class="col-12 m-0 p-0" *ngIf="groupPortalDataService.editResidencyInformation">
        <div class="container-fluid d-inline-flex m-0 p-0 pb-4
                justify-content-end">
            <button id="btnSaveGroupInfo" (click)="saveGroupInformation()" class="btn btn-blue" title="Save">
                Save
            </button>
        </div>

    </div>

    <div class="row grpTitles">
        <hr class="gpTborder w-100 m-3" />
        <div class="col-12 subTitle py-3">
            <strong>Program Media</strong>
            <div style="float: right;" class="bkg-circle {{
                    !groupPortalDataService.editProgramMedia
                    ? 'pencil'
                    : 'icon-closex'
                    }}">
                <a (click)="toggleSection('editProgramMedia')"><i class="fa
                            {{
                            !groupPortalDataService.editProgramMedia
                            ? 'fa-pencil'
                            : 'hidden'
                            }}"></i></a>
            </div>
        </div>
    </div>

    <div *ngIf="!groupPortalDataService.editProgramMedia" class="programMedia
            col-8 px-0">
        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.webSite">
            <a class="pmLink btn-icon icon-globe" href="{{
                    (!groupPortalDataService.groupList.GroupInfo?.webSite) ? '' :
                    groupPortalDataService.groupList.GroupInfo?.webSite }}" target="_blank"> <span class="linkText">{{
                    groupPortalDataService.groupList.GroupInfo?.webSite }}</span></a>
        </div>
        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.multiMedia">
            <a class="pmLink btn-icon" target="_blank" href="{{
                    (!groupPortalDataService.groupList.GroupInfo?.multiMedia) ? ''
                    : groupPortalDataService.groupList.GroupInfo?.multiMedia }}">
                <span class="bkg-circle icon-monitor faux-fa"></span>
                <span class="linkText">{{
                    groupPortalDataService.groupList.GroupInfo?.multiMedia }}</span></a>
        </div>
        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.multiMedia2">
            <a class="pmLink btn-icon" target="_blank" href="{{
                    (!groupPortalDataService.groupList.GroupInfo?.multiMedia2) ?
                    '' : groupPortalDataService.groupList.GroupInfo?.multiMedia2
                    }}">
                <span class="bkg-circle icon-monitor faux-fa"></span>
                <span class="linkText">{{
                    groupPortalDataService.groupList.GroupInfo?.multiMedia2 }}</span></a>
        </div>
        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.multiMedia3">
            <a class="pmLink btn-icon" target="_blank" href="{{
                    (!groupPortalDataService.groupList.GroupInfo?.multiMedia3) ?
                    '' : groupPortalDataService.groupList.GroupInfo?.multiMedia3
                    }}">
                <span class="bkg-circle icon-monitor faux-fa"></span>
                <span class="linkText">{{
                    groupPortalDataService.groupList.GroupInfo?.multiMedia3 }}</span></a>
        </div>
    </div>

    <div class="FlowupLabels col-8 p-0 pmEdit" *ngIf="groupPortalDataService.editProgramMedia">
        <div class="fl_wrap icon-nav" [ngClass]="{
                populated: groupPortalDataService.groupList.FormGroupInfo?.webSite
                }">
            <a class="btn-icon icon-globe"></a>
            <label class="fl_label" for="webSite">Website</label>
            <input class="fl_input" name="webSite" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.webSite" />
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{
                populated:
                groupPortalDataService.groupList.FormGroupInfo?.multiMedia
                }">
            <a class="btn-icon"><span class="bkg-circle icon-monitor
                        faux-fa"></span></a>
            <label class="fl_label" for="multiMedia">Link to other program
                media</label>
            <input class="fl_input" name="multiMedia" type="textbox" placeholder="" [(ngModel)]="
                    groupPortalDataService.groupList.FormGroupInfo.multiMedia
                    " />
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{
                populated:
                groupPortalDataService.groupList.FormGroupInfo?.multiMedia2
                }">
            <a class="btn-icon"><span class="bkg-circle icon-monitor
                        faux-fa"></span></a>
            <label class="fl_label" for="multiMedia2">Link to other program
                media</label>
            <input class="fl_input" name="multiMedia2" type="textbox" placeholder="" [(ngModel)]="
                    groupPortalDataService.groupList.FormGroupInfo.multiMedia2
                    " />
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{
                populated:
                groupPortalDataService.groupList.FormGroupInfo?.multiMedia3
                }">
            <a class="btn-icon"><span class="bkg-circle icon-monitor
                        faux-fa"></span></a>
            <label class="fl_label" for="multiMedia3">Link to other program
                media</label>
            <input class="fl_input" name="multiMedia3" type="textbox" placeholder="" [(ngModel)]="
                    groupPortalDataService.groupList.FormGroupInfo.multiMedia3
                    " />
        </div>
    </div>

    <div class="col-12 m-0 p-0" *ngIf="groupPortalDataService.editProgramMedia">
        <div class="container-fluid d-inline-flex m-0 p-0 pb-4
                justify-content-end">
            <button id="btnSaveGroupInfo" (click)="saveGroupInformation()" class="btn btn-blue" title="Save">
                Save
            </button>
        </div>
    </div>

    <div class="row grpTitles">
        <hr class="gpTborder w-100 m-3" />
        <div class="col-12 subTitle py-3">
            <strong>Social Media</strong>
            <div style="float: right;" class="bkg-circle {{
                    !groupPortalDataService.editSocialMedia
                    ? 'pencil'
                    : 'icon-closex'
                    }}">
                <a (click)="toggleSection('editSocialMedia')"><i class="fa
                            {{
                            !groupPortalDataService.editSocialMedia
                            ? 'fa-pencil'
                            : 'hidden'
                            }}"></i></a>
            </div>
        </div>
    </div>

    <div *ngIf="!groupPortalDataService.editSocialMedia" class="programMedia
            col-8 px-0">
        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.twitter">
            <a class="pmLink btn-icon twselect" target="_blank" href="{{
                    (!groupPortalDataService.groupList.GroupInfo?.twitter) ? '' :
                    groupPortalDataService.groupList.GroupInfo?.twitter }}">
                <span class="linkText">{{
                    groupPortalDataService.groupList.GroupInfo?.twitter }}</span></a>
        </div>
        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.facebook">
            <a class="pmLink btn-icon fbselect" target="_blank" href="{{
                    (!groupPortalDataService.groupList.GroupInfo?.facebook) ? '' :
                    groupPortalDataService.groupList.GroupInfo?.facebook }}">
                <span class="linkText">{{
                    groupPortalDataService.groupList.GroupInfo?.facebook }}</span></a>
        </div>
        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.instagram">
            <a class="pmLink btn-icon icon-insta" target="_blank" href="{{
                    (!groupPortalDataService.groupList.GroupInfo?.instagram) ? ''
                    : groupPortalDataService.groupList.GroupInfo?.instagram }}">
                <span class="bkg-circle"><i class="fa fa-instagram"></i></span>
                <span class="linkText">{{
                    groupPortalDataService.groupList.GroupInfo?.instagram }}</span></a>
        </div>
        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.youtube">
            <a class="pmLink btn-icon icon-youtube" target="_blank" href="{{
                    (!groupPortalDataService.groupList.GroupInfo?.youtube) ? '' :
                    groupPortalDataService.groupList.GroupInfo?.youtube }}">
                <span class="linkText">{{
                    groupPortalDataService.groupList.GroupInfo?.youtube }}</span></a>
        </div>
        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.vimeo">
            <a class="pmLink btn-icon icon-vimeo" target="_blank" href="{{
                    (!groupPortalDataService.groupList.GroupInfo?.vimeo) ? '' :
                    groupPortalDataService.groupList.GroupInfo?.vimeo }}">
                <span class="linkText">{{
                    groupPortalDataService.groupList.GroupInfo?.vimeo }}</span></a>
        </div>
    </div>
    <div class="FlowupLabels col-8 p-0 pmEdit" *ngIf="groupPortalDataService.editSocialMedia">
        <div class="fl_wrap icon-nav" [ngClass]="{
                populated: groupPortalDataService.groupList.FormGroupInfo?.twitter
                }">
            <a class="btn-icon twselect"></a>
            <label class="fl_label" for="twitter">Twitter</label>
            <input class="fl_input" name="twitter" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.twitter" />
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{
                populated:
                groupPortalDataService.groupList.FormGroupInfo?.facebook
                }">
            <a class="btn-icon fbselect"></a>
            <label class="fl_label" for="facebook">Facebook</label>
            <input class="fl_input" name="facebook" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.facebook" />
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{
                populated:
                groupPortalDataService.groupList.FormGroupInfo?.instagram
                }">
            <a class="btn-icon icon-insta"><span class="bkg-circle"><i class="fa fa-instagram"></i></span></a>
            <label class="fl_label" for="instagram">Instagram</label>
            <input class="fl_input" name="instagram" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.instagram" />
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{
                populated: groupPortalDataService.groupList.FormGroupInfo?.youtube
                }">
            <a class="btn-icon icon-youtube"></a>
            <label class="fl_label" for="youtube">Youtube</label>
            <input class="fl_input" name="youtube" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.youtube" />
        </div>
        <div class="fl_wrap icon-nav" [ngClass]="{
                populated: groupPortalDataService.groupList.FormGroupInfo?.vimeo
                }">
            <a class="btn-icon icon-vimeo"></a>
            <label class="fl_label" for="vimeo">Vimeo</label>
            <input class="fl_input" name="vimeo" type="textbox" placeholder=""
                [(ngModel)]="groupPortalDataService.groupList.FormGroupInfo.vimeo" />
        </div>
    </div>

    <div class="col-12 m-0 p-0" *ngIf="groupPortalDataService.editSocialMedia">
        <div class="container-fluid d-inline-flex m-0 p-0 pb-4
                justify-content-end">
            <button id="btnSaveGroupInfo" (click)="saveGroupInformation()" class="btn btn-blue" title="Save">
                Save
            </button>
        </div>
    </div>


    <div class="row grpTitles">
        <hr class="gpTborder w-100 m-3" />
        <div class="col-12 subTitle py-3">
            <strong>Program Leadership</strong>
            <div style="float: right;" class=" bkg-circle {{
                    !groupPortalDataService.editProgramLeadership
                    ? 'pencil'
                    : 'icon-closex'
                    }}">
                <a (click)="toggleSection('editProgramLeadership')"><i class="fa {{
                            !groupPortalDataService.editProgramLeadership
                            ? 'fa-pencil'
                            : 'hidden'
                            }}"></i></a>
            </div>
        </div>
    </div>
    <!-- Add back in section above if desired -->
    <!-- <div class="col-12 justify-content-end d-flex px-0 mt-5 mb-3" *ngIf="groupPortalDataService.editProgramLeadership">
				<button id="btnAddLeadership" [disabled]="!groupPortalDataService.newContact.contactNo" (click)="addNewLeadership()" class="btn btn-blue btn-outline-maybe" title="Add Leadership">
					+ Add Leadership
				</button>
			</div> -->
    <div class="programLeadership">
        <div class="result-grid col-12">
            <div class="row headerRow-25 mb-2">
                <div class=" sort d-flex" [ngClass]="{'col-md-3':
                        groupPortalDataService.editProgramLeadership, 'col-md-4':
                        !groupPortalDataService.editProgramLeadership}">
                    <strong>Name</strong>
                </div>
                <div class="col-md-3 sort d-flex">
                    <strong>Email</strong>
                </div>
                <div class="col-md-3 sort d-flex">
                    <strong>Role</strong>
                </div>
                <!-- Paresh: Coding-1806 -->
                <div class="col-md-2 sort d-flex">
                    <span *ngIf="groupPortalDataService.groupList.GroupInfo?.residencyDetail" style="width: 100%">
                        <strong>End Date</strong>
                    </span>
                </div>
                <!-- End -->
                <div class="col-md-1 sort d-flex justify-content-end
                        pr-md-4" *ngIf="groupPortalDataService.editProgramLeadership">
                    <strong>Delete</strong>
                </div>
            </div>
            <!-- Paresh: Coding-1860 Changed condition to include EMRA roles and to show only active contacts -->
            <div class="FlowupLabels row groupMembers py-1" [ngClass]="{'plEdit border-bottom':
                    groupPortalDataService.editProgramLeadership}" *ngFor="
                    let contact of groupPortalDataService.groupList.FormGroupInfo
                    ?.groupContacts
                    " [hidden]="
                    !(
                    contact.position == 'Group Administrator' ||
                    contact.position == 'Residency Director' ||
                    contact.position == 'Coordinator' ||
                    (contact.position == groupPortalDataService.EMRAResRepText &&
                    (contact.endDate == null || contact.endDate == '' ||
                    ConvertStringToDate(contact.endDate)>
                    ConvertStringToDate(todayDate))) ||
                    (contact.position == groupPortalDataService.EMRAResAltRepText && (contact.endDate == null ||
                    contact.endDate == '' ||
                    ConvertStringToDate(contact.endDate) >
                    ConvertStringToDate(todayDate)))
                    )
                    ">
                <div class=" d-flex" [ngClass]="{'col-md-3':
                        groupPortalDataService.editProgramLeadership, 'col-md-4':
                        !groupPortalDataService.editProgramLeadership}">
                    {{ contact.formalName }}
                </div>
                <div class="col-md-3 d-flex wrap-text right-padding">
                    {{ contact.email }}
                </div>
                <div class="col-md-3 d-flex right-padding">
                    {{ contact.position !== 'Coordinator' ? contact.position
                    : 'Residency Coordinator' }}
                </div>
                <!-- Paresh: Coding-1806 -->
                <div class="col-md-2 d-flex" *ngIf="!groupPortalDataService.editProgramLeadership">
                    <span *ngIf="groupPortalDataService.groupList.GroupInfo?.residencyDetail" style="width: 100%">
                        {{ contact.endDate | date:'MM/dd/yyyy' }}
                    </span>
                </div>
                <div class="col-md-2 d-flex" *ngIf="groupPortalDataService.editProgramLeadership">
                    <span *ngIf="groupPortalDataService.groupList.GroupInfo?.residencyDetail" style="width: 100%">
                        <div style="width: 100%;" *ngIf="contact.position ==
                            groupPortalDataService.EMRAResRepText ||
                                contact.position == groupPortalDataService.EMRAResAltRepText">
                            <input matInput class="fl_input" id="extEndDate" (dateChange)="onEndDateChanged(contact)"
                                [(ngModel)]="contact.tempEndDate" [matDatepicker]="extEndDate">
                            <mat-datepicker-toggle matSuffix [for]="extEndDate"
                                style="float: right;"></mat-datepicker-toggle>
                            <mat-datepicker #extEndDate disabled="false"></mat-datepicker>
                        </div>
                    </span>
                </div>
                <!-- End -->
                <div class="col-md-1 d-flex justify-content-end pr-md-2"
                    *ngIf="groupPortalDataService.editProgramLeadership">
                    <div class="delete icon-trash btn-icon" (click)="confirmRemoveParticipant(contact)"></div>
                </div>
            </div>

            <div class="row py-3 border-bottom FlowupLabels
                    align-items-center" *ngIf="groupPortalDataService.editProgramLeadership">
                <div class="col-md-3 sort d-block mb-0">

                    <div class="fl_wrap mb-0" [ngClass]="{ populated:
                            groupPortalDataService.newContact.formalName !== '' }" [hidden]="groupPortalDataService.newContact.contactNo
                            !== null">
                        <label class="fl_label" for="searchMember">Search by
                            First Name, Last Name, or NPI Number</label>
                        <input class="fl_input" name="searchMember" type="textbox" placeholder=""
                            [(ngModel)]="groupPortalDataService.newContact.formalName"
                            (keyup)="searchForMembers($event)" />
                    </div>
                    <div class="closeListBlock" [hidden]="!showSearchContactList" (click)="closeListBlock($event)">
                    </div>
                    <div class="nlblock listBlock" [ngClass]="{'border':
                            showSearchContactList}">
                        <ul [hidden]="!showSearchContactList" class="nameList">
                            <li *ngFor="
                                    let contacts of groupPortalDataService
                                    .groupList?.searchContactList
                                    " (click)="
                                    setshowContactForm(contacts, true)
                                    ">
                                {{ contacts.formalName }} {{
                                contacts.npiNumber }} {{ contacts.city }} {{
                                contacts.state }}
                            </li>
                            <li (click)="setshowContactForm(0, true)">
                                Can't find who I'm looking for
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="groupPortalDataService.newContact.contactNo
                            !== null">
                        {{ groupPortalDataService.newContact.formalName }}
                    </div>
                </div>
                <div class="col-md-3 sort d-flex wrap-text">
                    {{ groupPortalDataService.newContact.email }}
                </div>
                <div *ngIf="groupPortalDataService.groupList.GroupInfo?.residencyDetail" class="col-md-3 sort d-flex fl_wrap align-items-center
                        {{(groupPortalDataService.newContact.contactNo === null ||
                        groupPortalDataService.newContact.position !== '' ? '' :
                        (formsubmitted ? ' validation-error' : ''))}}">
                    <select style="width: 95%;" class="fl_input" name="role" (change)="checkLeadershipAmounts()"
                        [(ngModel)]="groupPortalDataService.newContact.position">
                        <option value="Group Administrator">Group
                            Administrator</option>
                        <option value="Residency Director">Residency
                            Director</option>
                        <option value="Coordinator">Residency Coordinator</option>
                        <!-- Paresh: Coding-1860 -->
                        <option [value]="groupPortalDataService.EMRAResRepText">
                            {{groupPortalDataService.EMRAResRepText}}</option>
                        <option [value]="groupPortalDataService.EMRAResAltRepText">EMRA Program Alternate Rep</option>
                        <!-- End -->
                    </select>
                    <div><span class="validationhead">Required</span></div>
                </div>
                <div *ngIf="groupPortalDataService.groupList.GroupInfo?.physgrpDetail"
                    class="col-md-3 sort d-flex fl_wrap align-items-center">
                    {{groupPortalDataService.newContact.position}}
                </div>
                <!-- Paresh: Coding-1860 -->
                <div class="col-md-2 d-flex sort" style="margin-bottom:
                        2px;">
                    <span *ngIf="groupPortalDataService.groupList.GroupInfo?.residencyDetail" style="width: 100%">
                        <div *ngIf="this.showEndDate">
                            <input class="fl_input" id="endDate"
                                (dateChange)="onEndDateChanged(groupPortalDataService.newContact)" matInput
                                [(ngModel)]="groupPortalDataService.newContact.tempEndDate" [matDatepicker]="endDate">
                            <mat-datepicker-toggle matSuffix [for]="endDate"
                                style="float: right;"></mat-datepicker-toggle>
                            <mat-datepicker #endDate disabled="false"></mat-datepicker>
                        </div>
                    </span>
                </div>
                <!-- End -->
                <div class="col-md-1 sort d-flex justify-content-end
                        pr-md-2">
                    <div class="delete icon-trash btn-icon" *ngIf="groupPortalDataService.newContact.contactNo !==
                            null" (click)="groupPortalDataService.setNewContact();
                            checkLeadershipAmounts()"></div>
                </div>
            </div>
            <div class="row my-2">
                <div class="align-items-center d-flex" [ngClass]="{'col-6':
                        (maxGroupAdmin || maxResidencyCoordinator ||
                        maxResidencyDirector|| maxEMRAResRep || maxEMRAResAltRep
                        || !dateEntered)}" *ngIf="maxGroupAdmin ||
                        maxResidencyCoordinator || maxResidencyDirector ||
                        maxEMRAResRep || maxEMRAResAltRep || !dateEntered">
                    <div class="fl_wrap validation-error" *ngIf="maxGroupAdmin">
                        <span class="error"><i class="fa
                                    fa-exclamation-triangle"></i> No more than 3
                            Group Administrators</span>
                    </div>
                    <div class="fl_wrap validation-error" *ngIf="maxResidencyDirector">
                        <span class="error"><i class="fa
                                    fa-exclamation-triangle"></i> No more than 1
                            Residency Directory</span>
                    </div>
                    <div class="fl_wrap validation-error" *ngIf="maxResidencyCoordinator">
                        <span class="error"><i class="fa
                                    fa-exclamation-triangle"></i> No more than 1
                            Residency Coordinator</span>
                    </div>
                    <!-- Paresh: Coding-1860 -->
                    <div class="fl_wrap validation-error" *ngIf="maxEMRAResRep">
                        <span class="error"><i class="fa
                                    fa-exclamation-triangle"></i> No more than 1 {{
                            groupPortalDataService.EMRAResRepText }}</span>
                    </div>
                    <div class="fl_wrap validation-error" *ngIf="maxEMRAResAltRep">
                        <span class="error"><i class="fa
                                    fa-exclamation-triangle"></i> No more than 1
                            {{ groupPortalDataService.EMRAResAltRepText }}</span>
                    </div>
                    <div class="fl_wrap validation-error" *ngIf="!dateEntered">
                        <span class="error"><i class="fa
                                    fa-exclamation-triangle"></i> End Date is
                            required for EMRA Representative</span>
                    </div>
                    <!-- End -->
                </div>
                <div class=" d-inline-flex justify-content-end
                        align-items-center" [ngClass]="{'col-6': (maxGroupAdmin
                        || maxResidencyCoordinator || maxResidencyDirector ||
                        maxEMRAResRep || maxEMRAResAltRep || !dateEntered),
                        'col-12': !(maxGroupAdmin || maxResidencyCoordinator ||
                        maxResidencyDirector || maxEMRAResRep ||
                        maxEMRAResAltRep || !dateEntered)}">
                    <div class="container-fluid d-inline-flex m-0 p-0 pb-4
                            justify-content-end" *ngIf="groupPortalDataService.editProgramLeadership">
                        <button id="btnSaveGroupInfo" [disabled]="!groupPortalDataService.newContact.contactNo
                                && !deletedContact && !existingDateEdit" (click)="saveGroupInformation(true)" class="btn
                                btn-blue" title="Save">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="FlowupLabels programEMRAMatchInfo" *ngIf="groupPortalDataService.groupList.GroupInfo?.physgrpDetail">
        <div class="row grpTitles">
            <hr class="gpTborder w-100 m-3" />
            <div class="col-12 subTitle py-3">
                <strong>Program Information</strong>
            </div>
        </div>

        <!-- Group Size -->
        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Size</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editGroupSize">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.physgrpDetail.size
                    }}
                </span>
            </div>
            <div class="col-1">
                <div class="bkg-circle {{
                        !groupPortalDataService.editGroupSize
                        ? 'pencil'
                        : 'icon-closex'
                        }}">
                    <a (click)="toggleSection('editGroupSize')">
                        <i class="fa {{
                                !groupPortalDataService.editGroupSize
                                ? 'fa-pencil'
                                : 'hidden'
                                }}"></i></a>
                </div>
            </div>
            <div class="col-12" *ngIf="groupPortalDataService.editGroupSize">
                <div class="radioWrap ml-0 pl-0" *ngIf="groupPortalDataService.editGroupSize">
                    <p>What is the group size?</p>
                    <input name="groupSize" type="radio" value="<50" id="size_lessThan50" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.size
                            " />
                    <label for="size_lessThan50">&lt; 50</label>
                    <input name="groupSize" type="radio" value="51 - 100" id="size_51to100" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.size
                            " />
                    <label for="size_51to100">51 - 100</label>
                    <input name="groupSize" type="radio" value="101 - 250" id="size_101to250" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.size
                            " />
                    <label for="size_101to250">101 - 250</label>
                    <input name="groupSize" type="radio" value="251 - 500" id="size_251to500" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.size
                            " />
                    <label for="size_251to500">251 - 500</label>
                    <input name="groupSize" type="radio" value="501 - 1000" id="size_501to1000" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.size
                            " />
                    <label for="size_501to1000">501 - 1000</label>
                    <input name="groupSize" type="radio" value="1001 - 2000" id="size_1001to2000" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.size
                            " />
                    <label for="size_1001to2000">1001 - 2000</label>
                    <input name="groupSize" type="radio" value="2000 +" id="size_2001+" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.size
                            " />
                    <label for="size_2001+">2001+</label>
                </div>
                <div class="col-12">
                    <div class="container-fluid d-inline-flex m-0 p-0 pb-4
                            justify-content-end">
                        <button id="btnSaveGroupInfo" [disabled]="
                                groupPortalDataService.groupList.FormGroupInfo
                                ?.physgrpDetail.size === null
                                " (click)="saveGroupInformation()" class="btn
                                btn-blue" title="Save">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Group Type -->
        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Type</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editGroupType">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.physgrpDetail.type
                    }}
                </span>
            </div>
            <div class="col-1">
                <div class="bkg-circle {{
                        !groupPortalDataService.editGroupType
                        ? 'pencil'
                        : 'icon-closex'
                        }}">
                    <a (click)="toggleSection('editGroupType')">
                        <i class="fa {{
                                !groupPortalDataService.editGroupType
                                ? 'fa-pencil'
                                : 'hidden'
                                }}"></i></a>
                </div>
            </div>
            <div class="col-12" *ngIf="groupPortalDataService.editGroupType">
                <div class="radioWrap ml-0 pl-0" *ngIf="groupPortalDataService.editGroupType">
                    <p>What is the group type?</p>
                    <input name="groupType" type="radio" value="Academic" id="type_Academic" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.type
                            " />
                    <label for="type_Academic">Academic</label>
                    <input name="groupType" type="radio" value="Employment" id="type_Employment" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.type
                            " />
                    <label for="type_Employment">Employment</label>
                    <input name="groupType" type="radio" value="Hospital" id="type_Hospital" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.type
                            " />
                    <label for="type_Hospital">Hospital</label>
                    <input name="groupType" type="radio" value="Independent" id="type_Independent" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.type
                            " />
                    <label for="type_Independent">Independent</label>
                </div>
                <div class="col-12">
                    <div class="container-fluid d-inline-flex m-0 p-0 pb-4
                            justify-content-end">
                        <button id="btnSaveGroupInfo" [disabled]="
                                groupPortalDataService.groupList.FormGroupInfo
                                ?.physgrpDetail.type === null
                                " (click)="saveGroupInformation()" class="btn
                                btn-blue" title="Save">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- ManagementStyle -->
        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Management Style</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editManagementStyle">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.physgrpDetail.managementStyle
                    }}
                </span>
            </div>
            <div class="col-1">
                <div class="bkg-circle {{
                        !groupPortalDataService.editManagementStyle
                        ? 'pencil'
                        : 'icon-closex'
                        }}">
                    <a (click)="toggleSection('editManagementStyle')">
                        <i class="fa {{
                                !groupPortalDataService.editManagementStyle
                                ? 'fa-pencil'
                                : 'hidden'
                                }}"></i></a>
                </div>
            </div>
            <div class="col-12" *ngIf="groupPortalDataService.editManagementStyle">
                <div class="radioWrap ml-0 pl-0" *ngIf="groupPortalDataService.editManagementStyle">
                    <p>How is the group managed?</p>
                    <input name="managementStyle" type="radio" value="Academic/Teaching Hospital"
                        id="managementStyle_academic" [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.managementStyle
                            " />
                    <label for="managementStyle_academic">Academic/Teaching
                        Hospital</label>
                    <input name="managementStyle" type="radio" value="Corporate" id="managementStyle_Corporate"
                        [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.managementStyle
                            " />
                    <label for="managementStyle_Corporate">Corporate</label>
                    <input name="managementStyle" type="radio" value="Democratic" id="managementStyle_Democratic"
                        [(ngModel)]="
                            groupPortalDataService.groupList.FormGroupInfo
                            ?.physgrpDetail.managementStyle
                            " />
                    <label for="managementStyle_Democratic">Democratic</label>
                </div>
                <div class="col-12">
                    <div class="container-fluid d-inline-flex m-0 p-0 pb-4
                            justify-content-end">
                        <button id="btnSaveGroupInfo" [disabled]="
                                groupPortalDataService.groupList.FormGroupInfo
                                ?.physgrpDetail.managementStyle === null
                                " (click)="saveGroupInformation()" class="btn
                                btn-blue" title="Save">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- In Group Billing -->
        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">In Group Billing</span>
            </div>
            <div class="col-6">
                <span>
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.physgrpDetail.inGroupBilling
                    }}
                </span>
            </div>
            <div class="col-1">

            </div>

        </div>

    </div>
    <div class="FlowupLabels programEMRAMatchInfo" *ngIf="groupPortalDataService.groupList.GroupInfo?.residencyDetail">
        <div class="row grpTitles">
            <hr class="gpTborder w-100 m-3" />
            <div class="col-7 subTitle py-3">
                <!-- Paresh: Coding-2260 -->
                <strong>Program EMRA Match Filters</strong>
            </div>
            <div class="col-5" style="float: right; top: 22px">
                <span>To update residency site information, please visit <a target="_blank" href="https://www.match.emra.org/">emramatch.org</a>.</span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">NRMP Number</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editNRMPNumber">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.nrmpCode
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">ACGME ID Number</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editACGMEID">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.acgmeId
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Program Length</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editprogramLength">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.programLength
                    }}
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.programLength === null
                    ? ""
                    : "Year"
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Dual Training Options</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editTrainingOptions">
                    {{ groupPortalDataService.specialty }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Primary Training Site</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editprimaryTrainingSite">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.primaryTrainingSite
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Secondary Training Site</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editsecondaryTrainingSite">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.secondaryTrainingSite
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Shift Length (Hours)</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editshiftLength">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.shiftLength
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Shifts Per Month</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editshiftsPerMonth">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.shiftsPerMonth
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">PGY1 Percent Off-Service</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editpgy1PercentOffService">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.pgy1PercentOffService
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Available Intern Positions</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editavailableInternpositions">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.availableInternpositions
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Applications Received</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editapplicationsReceived">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.applicationsReceived
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Step 1 Failures</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editstep1failures">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.step1Failures
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Step 1 Cutoff</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editstep1cutoff">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.step1Cutoff
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Percent Osteopath</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editpercentosteopath">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.percentOsteopath
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Percent IMG</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editpercentimg">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.percentImg
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Moonlighting</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editmoonlighting">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.moonLighting
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Elective Weeks</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editelectiveweeks">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.electiveWeeks
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Critical Care Training Weeks</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editcriticalcaretraining">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.criticalCareTraining
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Military Branch</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editmilitarybranch">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.militaryBranch
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">Visa Sponsorship</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editvisasponsorship">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.visaSponsorship
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">SLOEs for Interview</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editsloesforinterview">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.sloesForInterview
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="col-5">
                <span class="bold">USMLE/COMLEX Preference</span>
            </div>
            <div class="col-6">
                <span *ngIf="!groupPortalDataService.editusmlecomlexpreferred">
                    {{
                    groupPortalDataService.groupList.GroupInfo
                    ?.residencyDetail.usmleComplexPreference
                    }}
                </span>
            </div>
        </div>

        <div class="row py-3 mx-0 border-top align-items-center">
            <div class="row info col-12">
                <div class="col-5">
                    <span class="bold">
                        Additional Information Students Should Know
                    </span>
                </div>
                <div class="col-6">
                    <span *ngIf="!groupPortalDataService.editprogramculture">
                        {{
                        groupPortalDataService.groupList.GroupInfo
                        ?.residencyDetail.programCulture
                        }}
                    </span>
                </div>
        </div>

    </div>
    <div class="remodal groupComponentHeading" data-remodal-id="deleteParticipant">
        <div class="bkg-circle icon-closex" (click)="cancelModal()"><a><i class="fa hidden"></i></a></div>
        <div class="modal-body">Are you sure you want to remove <br>{{selectedContact?.formalName}}?
            <br> Save after continuing to delete from your account.
        </div>

        <!-- <div class="div-padding-bottom-40"></div> -->
        <button data-remodal-action="cancel" id="btnModalCancel" title="NO,
                Do not remove from group" class="btn btn-gpGray float-left" (click)="cancelModal()">Cancel</button>
        <button data-remodal-action="confirm" id="btnModalConfirm" title="YES, Remove from group"
            class="btn btn-blue float-right" (click)="deleteContact()">Continue</button>
    </div>
    <!-- Paresh: Coding-1860 New popup dialog for confirmation -->
    <div class="remodal groupComponentHeading" data-remodal-id="setPastEndDate">
        <div class="bkg-circle icon-closex" (click)="cancelEndDateModal()"><a><i class="fa hidden"></i></a></div>
        <div class="modal-body">Adding a date in the past will deactivate
            this contact, Are you sure you want to continue?
            <br> Save after setting the End Date.
        </div>

        <!-- <div class="div-padding-bottom-40"></div> -->
        <button data-remodal-action="cancel" id="btnEndModalCancel"
            title="NO, Do not change the end date and keep the original" class="btn btn-gpGray float-left"
            (click)="cancelEndDateModal()">Cancel</button>
        <button data-remodal-action="confirm" id="btnEndModalConfirm" title="YES, Change the end date" class="btn btn-blue
                float-right" (click)="changeEndDate()">Continue</button>
    </div>
</div>

<div class="componentLoader" [ngClass]="{ hidethis:
        groupPortalDataService.showGroupInfo }"></div>